import { Deserializable } from '../protocols/deserializable';

export class SubmissionHistoryItem implements Deserializable {
  public id!: string;
  public memberSubmissionId!: string;
  public event!: string;
  public eventDate!: string | null;

  onDeserialize() {}
}
